import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import settings from '../conf'

export const STORAGE_KEY = 'forwalk-settings'

export const parseSettings = (value) => {
    try {
        return JSON.parse(value) 
    } catch (error) {
        return {}
    }
}

const getBestZoom = () => {
    const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if (1000 < width < 1400){
        return .9
    } else {
        return 1
    }
}

export const getSettings = () => {
  return Object.assign(
    settings.USER_SETTINGS || {}, 
    {zoom: getBestZoom()},
    parseSettings(localStorage.getItem(STORAGE_KEY))
  );
}


const initialState = getSettings()

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings(state, action) {
      Object.assign(state, action.payload)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }
  }
})


export const useSettings = () => useSelector( state => state.settings )
export const { setSettings } = settingsSlice.actions
export default settingsSlice
